export default {"src":"/_next/static/media/cuisine.f2209498.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};